import { useState } from 'react';
import { FEEDBACK_VALUE } from '../panda.constants';
import type { FeedbackValue } from '../panda.constants';

/**
 * Thumbs up/down selection for an answer: tap selects, re-tap clears. Selection
 * is UI state only; each change is reported via `onFeedback` (analytics), never
 * persisted.
 */
export function useFeedbackToggle(onFeedback: (value: FeedbackValue) => void) {
  const [feedback, setFeedback] = useState<FeedbackValue>(null);

  const toggleFeedback = (value: Exclude<FeedbackValue, null>) => {
    const next = feedback === value ? null : value;
    setFeedback(next);
    onFeedback(next);
  };

  return {
    isPositive: feedback === FEEDBACK_VALUE.POSITIVE,
    isNegative: feedback === FEEDBACK_VALUE.NEGATIVE,
    toggleFeedback,
  };
}
